var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.0024 21.9951C17.5253 21.9951 22.0024 17.518 22.0024 11.9951C22.0024 6.47227 17.5253 1.99512 12.0024 1.99512C6.47959 1.99512 2.00244 6.47227 2.00244 11.9951C2.00244 17.518 6.47959 21.9951 12.0024 21.9951Z",
    fill: "#1D453F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 15.9278C15.58 15.9278 15.45 15.8978 15.33 15.8178L12.23 13.9678C11.46 13.5078 10.89 12.4978 10.89 11.6078V7.50781C10.89 7.09781 11.23 6.75781 11.64 6.75781C12.05 6.75781 12.39 7.09781 12.39 7.50781V11.6078C12.39 11.9678 12.69 12.4978 13 12.6778L16.1 14.5278C16.46 14.7378 16.57 15.1978 16.36 15.5578C16.21 15.7978 15.96 15.9278 15.71 15.9278Z",
    fill: "#1D453F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2eafb5f16a8205092bab52d9d4a7028d.svg";
export { ForwardRef as ReactComponent };